module.exports = __webpack_public_path__ + "media/images/element/category-2-6461406429a4add3050d224c91ed853b.svg";